<template>
  <div class="container">
    <div class="wrapper page-loader">
      <div id="page-preloader" class="preloader">
        <div class="loader progress">
          <div class="load-number" :data-percent="renderedPercentage" :data-percent-pr='pro'>
            <svg viewBox="-10 -10 220 220" width="100px">
              <g fill="none" stroke-width="6" transform="translate(100,100)">
                <path d="M 0,-100 A 100,100 0 0,1 86.6,-50" stroke="#998551" />
                <path d="M 86.6,-50 A 100,100 0 0,1 86.6,50" stroke="#998551" />
                <path d="M 86.6,50 A 100,100 0 0,1 0,100" stroke="#998551" />
                <path d="M 0,100 A 100,100 0 0,1 -86.6,50" stroke="#998551" />
                <path d="M -86.6,50 A 100,100 0 0,1 -86.6,-50" stroke="#998551" />
                <path d="M -86.6,-50 A 100,100 0 0,1 0,-100" stroke="#998551" />
              </g>
            </svg>
            <svg viewBox="-10 -10 220 220" width="100px">
              <path d="M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z" :stroke-dashoffset="numberProgress" stroke="#000000" fill="#000000" id="orange-circle"></path>
            </svg>
          </div>
          <div class="text-loading">turn<span> on </span>sound</div>
          <div class="loading-after"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '../main.js';
  import Pace from 'pace'

  export default {
    data: () => ({
      numberProgress: 0,
      percentageProgress: 0,
      pro: '%'
    }),
    computed: {
      renderedPercentage() {
        return this.percentageProgress 
      }
    },
    methods: {
      trackProgress() {
        let paceOptions = {
          elements: false,
          restartOnRequestAfter: false,
          target: '#page-preloader',
        }

        let percentage = 0;
        const percentageMax = 100;

        function convertRange(value, r1, r2) {
          return Math.ceil((value - r1[0]) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0]);
        }

        Pace.on('update', p => {
          percentage = Math.ceil(p)

          var numberProgress = convertRange(p, [1, 100], [1, 629]);
          this.percentageProgress = percentage;
          this.numberProgress = numberProgress;

        })

        Pace.on('done', function() {
          EventBus.$emit('pageLoaded')
        })

        Pace.start(paceOptions)

      }
    },
    created() {
      this.trackProgress()
    }
  }

</script>
<style type="text/css">
  @keyframes load {
    0% {
      stroke-dashoffset: 0
    }
  }
  .page-loader {
    background: url(../../assets/img/home-bg.jpg) no-repeat;
    background-size: cover;
  }
  .preloader {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: black;
    z-index: 2;
    transition: 1s all;
    opacity: 0.7;
    visibility: visible;
  }

  .preloader .text-loading {
    font-size: 14px;
    color: #fff;
    z-index: 10;
  }

  .preloader .text-loading span {
    color: #998551;
  }

  .preloader .loading-after {
    width: 100px;
    height: 2px;
    background: #998551;
    margin: 0 auto;
  }

  .preloader .loader {
    position: absolute;
    left: 50%;
    top: 51.5%;
    transform: translate(-50%, -51.5%);
    text-align: center;
  }

  .preloader .loader .load-number {
    display: inline-block;
    position: relative;
    text-align: center;
    color: #fff;
    font-size: 35px;
    font-family: 'Montserrat', sans-serif;
    max-width: 115px;
    max-height: 115px;
  }

  .preloader .loader .load-number:before {
    content: attr(data-percent-pr);
    position: absolute;
    width: 100%;
    top: 52%;
    right: -32%;
    transform: translateY(-52%);
    font-size: 18px;
  }

  .preloader .loader .load-number:after {
    content: attr(data-percent);
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: -3%;
    font-size: 35px;
    text-align: center;
  }

  .preloader .loader .load-number svg {
    width: 115px;
    height: 115px;
  }

  .preloader .loader .load-number svg:nth-child(2) {
    position: absolute;
    left: 0;
    top: 0;
    transform: rotate(-90deg);
  }

  .preloader .loader .load-number svg:nth-child(2) path {
    fill: none;
    stroke-width: 25;
    stroke-dasharray: 629;
    opacity: .9;
  }

</style>



// WEBPACK FOOTER //
// src/components/preloader.vue